import { makeCompoundContext } from "../../functional/compoundContext";
export const [LightboxContextProvider, useLightboxContext] = makeCompoundContext("Lightbox");
//# sourceMappingURL=context.js.map